import { render, staticRenderFns } from "./OverlayPromotion.vue?vue&type=template&id=9395930a"
import script from "./OverlayPromotion.vue?vue&type=script&lang=js"
export * from "./OverlayPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports